module.exports = __webpack_public_path__ + "media/images/app/testimonials/carousel-first-d25810ffef951d995bceaedaae102fb0.webp";